import React from "react";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import {
  getDateRangeMessage,
  getLocalizedReportDate,
} from "reports/shared/utils/util";
import ReportsMessages from "reports/intl/ReportsMessages";

const ReportDateRange = ({ definition }) => {
  const { startDate, endDate, timeWindow } = definition || {};
  const { formatMessage } = useIntl();

  // If we have custom date range with start/end dates
  if (startDate) {
    const formattedStart = getLocalizedReportDate(startDate);
    const formattedEnd = endDate
      ? getLocalizedReportDate(endDate)
      : formatMessage(ReportsMessages.lastUpdate);
    return <span>{`${formattedStart} - ${formattedEnd}`}</span>;
  }

  // Otherwise use the predefined date range message
  const message = getDateRangeMessage(timeWindow);
  const dateRangeMessage = formatMessage(message);
  return <span>{dateRangeMessage}</span>;
};

ReportDateRange.propTypes = {
  definition: PropTypes.shape({
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    timeRollup: PropTypes.string,
    timeWindow: PropTypes.string,
  }),
};

export default ReportDateRange;
